import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './styles/main.css'

const app = createApp(App)

// Global error handler
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue error:', err)
  console.error('Error info:', info)
  console.error('Component:', instance)
  // Could integrate with error reporting service (Sentry, etc.) in the future
}

app.use(createPinia())
app.use(router)

app.mount('#app')
